import Header from "./components/Header";
import FoodSearch from "./components/Factsheet/FoodSearch"
import { usePath } from "./libs/path/PathProvider";
import { useEffect, useState } from "react";
import Loading from "./gui/Loading/Loading";
import RecipeSearch from "./components/Recipe/RecipeSearch";
import FoodTabs from "./components/FoodTabs";
import FoodUtils from "./utils/FoodUtils";
import { combineClass } from "./libs/GWidget";
import Recipes from "./pages/Recipes";
import Factsheets from "./pages/Factsheets";
import Settings from "./components/Settings/Settings";
import { useLogin } from "./gui/Login/LoginProvider";
import Error from "./pages/Error";
import { useFoods } from "./utils/FoodProvider";
import useAddRecipe from "./components/Recipe/AddRecipeDlg";
import Meals from "./pages/Meals";
import useAddMeal from "./components/Meals/AddMealDlg";
import MealSearch from "./components/Meals/MealSearch";
import { useAuth } from "./gui/Login/AuthProvider";

export default function App(){
    const {path,setPath} = usePath()
    const [scroll,setScroll] = useState<boolean>(false)
    const {isLoggedIn} = useAuth()
    const {login} = useLogin()
    const {addRecipe} = useAddRecipe()
    const {addMeal} = useAddMeal()

    const {loadFoods,error,ready} = useFoods()

    useEffect(() => {loadFoods().catch( (e:any) => {})}, [])

    const onSearch = (id:number) => setPath(`/search/${id}`)
    const onAdd = () => {
        if (!isLoggedIn) return login(onAdd)
        switch(FoodUtils.getPage(path)){
        case "home":    addRecipe(); break;
        case "meals":   addMeal(); break;
        }
    }
    const onScroll = (e:any) => setScroll(e.target.scrollTop>0)
    
    let toolbar:React.ReactElement|null = null
    let content:React.ReactElement|null = null
    if (ready) {
        switch(FoodUtils.getPage(path)){
        case "home":
            toolbar = <RecipeSearch className={combineClass({scroll})}/>
            content = <Recipes/>
            break;
        case "meals":
            toolbar = <MealSearch className={combineClass({scroll})}/>
            content = <Meals/>
            break;
        case "search":
            toolbar = <FoodSearch onSearch={onSearch} className={combineClass({scroll})}/>
            content = <Factsheets/>
            break;
        case "settings":
            content = <Settings/>
            break;
        default: 
            setPath("/home")
        }
    }
    else if (error) content = <Error error={error}/>
    else content = <Loading className="mt-32"/>
    return <>
        <Header onAdd={onAdd}/>
        {toolbar}
        <div className="content flex1" onScroll={onScroll}>{content}</div>
        <FoodTabs disabled={!ready}/>
    </>
}